export default __webpack_public_path__ + "static/media/bakery_front.27d47da1.png";